import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../../widgets/tables/Table';
import WaitDialog from '../../widgets/WaitDialog';
import { NineCellLoading } from 'react-loadingg';
import SendMailWidget from '../../widgets/SendMailWidget';
import SendNotificationWidget from '../../widgets/SendNotificationWidget';
import GetInsegnanti from '../../services/getInsegnanti';
import DeleteInsegnante from '../../services/deleteInsegnante';
import Utils from '../../utils/utils';
import SelectPdfDatesWidget from '../../widgets/SelectPdfDatesWidget';
import FusioneWidget from '../../widgets/FusioneWidget';
import addGruppoInsegnanti from '../../services/addGruppoInsegnanti';
import addNotification from '../../services/addNotification';
import sendMail from "../../services/sendMail";
import getSetting from "../../services/getSetting";
import saveFile from "../../services/saveFile";
import addUtente from "../../services/addUtente";
import Button from '../../widgets/Button';
import generateExcel from "../../services/generateExcel";
import getPresenzeCorso from "../../services/getPresenzeCorso";
import getChiusura from "../../services/getChiusura";
import moment from 'moment';
import getPresenze from "../../services/getPresenze";
import Constants from "../../utils/consts";
import getLezioni from "../../services/getLezioni";
import WaitDialogFileDownload from "../../widgets/WaitDialogFileDownload";
import translateString from "../../utils/Locales";

let t = translateString;

export default class Corsi extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      waitDialogVisible: false,
      selectPdfDatesVisible: false,
      fusioneEnabled: false,
      insegnanti: [],
      gruppiInsegnantiComplete: [],
      mailCompaniesList: [],
      reportPeriod: '',
      waitDialogFileVisible: false,
      fileReady: false, 
      sendMailVisible: false,
      sendNotificationVisible: false,
    }

    this.grid = 2;
    this.tableRef = React.createRef();

    this.pdfElements = [];

    this.insegnanti = [];
    this.gruppiInsegnantiComplete = [];
    this.brokerId = undefined;

    const cookies = new Cookies();
    this.dbPath = cookies.get('db_path', { path: '/' });
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

  }


  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    Utils.setAnalyticsPage('Teachers list: ' + ' - ' + cookies.get('db', { path: '/' }));
    
    this.insegnanti = await GetInsegnanti(username, token);

    this.setState({
      insegnanti: this.insegnanti,
      fusioneEnabled: false, 
      isLoading: false,
    });
  }

  async componentDidMount(){
    await this.reload();
  }

  render () {

    var headCells = [
      { id: 'cognome', numeric: false, disablePadding: true, label: t('cognome') },
      { id: 'nome', numeric: false, disablePadding: true, label: t('nome') },
      { id: 'mail', numeric: true, disablePadding: false, label: 'Mail' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];

    this.searchCols = ['nome', 'cognome', 'materie', 'mail'];
    this.searchColsGroups = ['nome', 'insegnanti'];

    const cookies = new Cookies();

    this.tableRef.current && this.tableRef.current.clearSearch();

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (!this.state.gruppiInsegnantiComplete) return <div />;

    return (
      <div id={Math.random()}>
        <PageTitle title={t('insegnanti')} button={t('aggiungi')} onClick={() => {
          window.location.href =  '/' + this.dbPath + '/#/app/addInsegnante';
        }} />
        <div style={{ display: 'flex', marginTop: -30, marginBottom: 10, marginLeft: 5 }}>
                <img alt="" src={ require('../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                <p style={{ fontSize: 12, color: 'darkgray', maxWidth: '80%' }}>{t('insegnanti_info')}</p><br/>
          </div>

        <div style={{display: "inline-flex"}}>
          <div style={{lineHeight: '37px'}}>{t('inserisci_fatturazione')}</div>
          <input style={{marginLeft: 20, height: '37px'}} type="text" value={this.state.reportPeriod} onChange={(event) => this.setState({reportPeriod: event.target.value})} />
          <Button callback={() => {
                  var value = this.state.reportPeriod;
                  if (value == undefined){
                    Utils.showError(t('errore_periodo_ins'));
                    return;
                  }
                  var splitted = value.split('/');
                  if (splitted.length != 2 || isNaN(parseInt(splitted[0])) || isNaN(parseInt(splitted[1])) || parseInt(splitted[0]) > 12 || parseInt(splitted[0]) <= 0 || parseInt(splitted[1]) <= 1000){
                    Utils.showError(t('errore_periodo_ins'));
                    return;
                  }

                  const cookies = new Cookies();
                  cookies.set('reportMonth', parseInt(splitted[0]), { path: '/' });
                  cookies.set('reportYear', parseInt(splitted[1]), { path: '/' });
                  window.location.href= this.dbPath + '/#/app/pdfFatturatoPage';

                }} title={t('genera_pdf')}>      
          </Button>

          <Button callback={async () => {
                  var value = this.state.reportPeriod;
                  if (value == undefined){
                    Utils.showError(t('errore_periodo_ins'));
                    return;
                  }
                  var splitted = value.split('/');
                  if (splitted.length != 2 || isNaN(parseInt(splitted[0])) || isNaN(parseInt(splitted[1])) || parseInt(splitted[0]) > 12 || parseInt(splitted[0]) <= 0 || parseInt(splitted[1]) <= 1000){
                    Utils.showError(t('errore_periodo_ins'));
                    return;
                  }

                  this.setState({waitDialogFileVisible: true, fileReady: false});

                  const cookies = new Cookies();
                  const username = cookies.get('username', { path: '/' });
                  const token = cookies.get('token', { path: '/' });
                  const currentCorso = cookies.get('currentCorso', { path: '/' });
                  this.reportMonth = cookies.get('reportMonth', { path: '/' });
                  this.reportYear = cookies.get('reportYear', { path: '/' });

                  this.lezioni = await getLezioni(username, token);
                  this.corso = await getPresenzeCorso(username, token, currentCorso);
                  this.chiusura = await getChiusura(username, token);
                  this.insegnanti = await GetInsegnanti(username, token);

                  this.oreInsegnanti = {};
                  this.insegnanti.forEach(i => {
                    this.oreInsegnanti[i.id] = 0;
                  });

                  this.lezioni = this.lezioni.filter(l => {
                    var ll = moment(l.data, "yyyy-MM-DD HH:mm:ss");
                    if (ll.month() + 1 != this.reportMonth) return false;
                    if (ll.year() != this.reportYear) return false;
                    return true;
                  });

                  for (var l of this.lezioni) {

                    var registro = await getPresenze(username, token, l.id);
                    if (registro.length <= 0) continue;

                    var durata = l.durata / 60;
                    if (l.divisione_fatturato == 1){
                      var numInsegnanti = 1 + l.altri_insegnanti.split(';').length - 1;
                      durata = durata / numInsegnanti;
                    }
                    this.oreInsegnanti[l.id_insegnante] = this.oreInsegnanti[l.id_insegnante] + durata;
                    l.altri_insegnanti.split(';').forEach(id => {
                      this.oreInsegnanti[id] = this.oreInsegnanti[id] + durata;
                    })
                  }

                  var jsonData = [];
                  this.insegnanti && this.insegnanti.forEach(insegnante => {
                    jsonData.push([insegnante.nome + ' ' + insegnante.cognome, this.oreInsegnanti[insegnante.id]+ ' ore da fatturare'])
                  });

                  var jsonTabs = [];
                  jsonTabs.push({
                    name: t('fatturazione'),
                    data: jsonData
                  });

                  var json = {
                    tabs : jsonTabs
                  };

                  await generateExcel(username, token, JSON.stringify(json), t('fatturazione'));
                  this.setState({fileReady: true});

                }} title={t('genera_excel')}>      
          </Button>

        </div>

        <Table searchValue={''} id={Math.random()} headCells={headCells} searchCols={this.searchCols} mail={true} phone={true}  calendar={false} excel={false} pdf={true} invoices={true} rows={this.state.insegnanti} onEventClick={(row) => {
          cookies.set('currentInsegnante', row, { path: '/' });
          window.location.href =  '/' + this.dbPath + '/#/app/editInsegnante';
        }}

        onInvoicesPressed={(row) => {
          cookies.set('currentInsegnante', row, { path: '/' });
          window.location.href= '/' + this.dbPath + '/#/app/invoices';
        }}
        onSendMail={(id) => {
          this.sendMailRef.current && this.sendMailRef.current.reset();
          this.setState({sendMailVisible: true, sendMailUserId: [id]}); 
        } }

        onSendNotification={(id) => {
          this.sendNotificationRef.current && this.sendNotificationRef.current.reset();
          this.setState({sendNotificationVisible: true, notificationUser: [id]}); 
        } }

        onPdfClicked={elem => {
          this.setState({
            selectPdfDatesVisible: true,
            pdfElem: elem,
            pdfGroupElem: null
          })

        }}

        onDelete={async (id) => {
          if (window.confirm(t('elimina_insegnante')) == false) return;

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });
          await DeleteInsegnante(username, token, id);
          this.reload();
        }}

        onElementCheck={async (companyId) => {
          const cookies = new Cookies();

          var json = cookies.get('checksList', { path: '/' });
          var checksList = json.list;
          var index = checksList.indexOf(companyId);
          if (index != -1)
            checksList.splice(index, 1);
          else 
            checksList.push(companyId);

          cookies.set('checksList', JSON.stringify({list: checksList}), { path: '/' });
        }}

        />

        {this.elementPdf ? this.elementPdf : null}
        <SendMailWidget 
          ref={this.sendMailRef}
          show={this.state.sendMailVisible} 
          onClose={() => this.setState({sendMailVisible: false})}
          onSend={async (subject, body, file) => {
            
            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });
            this.mail = await getSetting(username, token, 'sendingMailAddress');
            if (this.mail === '') {
              Utils.showError(t('errore_manca_mail'));
              return;
            }
            this.mailName = await getSetting(username, token, 'sendingMailPassword');
            if (this.mailName === '') {
              Utils.showError(t('errore_manca_mail'));
              return;
            }

            var insegnantiMail = this.insegnanti.filter(s => this.state.sendMailUserId.indexOf(s.id) != -1);
            
            if (file != undefined){
              this.filePath = await saveFile(username, token, file.name, file.base64);
            }

            insegnantiMail.forEach(async insegnante => {

              insegnante.mail = insegnante.mail.trim();
              insegnante.mail2 = insegnante.mail2.trim();

              if (insegnante.mail != '' && Utils.validateEmail(insegnante.mail) == false){
                Utils.showError (t('l_indirizzo') + " " + insegnante.mail + t('non_valido'));
                return;
              }
              if (insegnante.mail2 != '' && Utils.validateEmail(insegnante.mail2) == false){
                Utils.showError (t('l_indirizzo') + " " + insegnante.mail2 + t('non_valido'));
                return;
              }

              if (insegnante.mail != '') 
                await sendMail(username, token, this.mail, this.mailName, insegnante.mail, insegnante.nome + ' ' + insegnante.cognome, file ? this.filePath.name : '', subject, body);
              if (insegnante.mail2 != '') 
                await sendMail(username, token, this.mail, this.mailName, insegnante.mail2, insegnante.nome + ' ' + insegnante.cognome, file ? this.filePath.name : '', subject, body);
            });

            this.setState({waitDialogVisible: false})
            this.setState({sendMailVisible: false})

        }}  
      />

      <SendNotificationWidget 
          ref={this.sendNotificationRef}
          show={this.state.sendNotificationVisible} 
          onClose={() => this.setState({sendNotificationVisible: false})}
          onSend={async (subject, body, bodyFull) => {
            
            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });

            this.state.notificationUser.forEach(async insegnante => {
              await addNotification(username, token, 'INSEGNANTE', insegnante, subject, body, bodyFull, 0);
            });

            this.setState({waitDialogVisible: false})
            this.setState({sendNotificationVisible: false})

        }}  
      />

    <SelectPdfDatesWidget show={this.state.selectPdfDatesVisible} key={Math.random()} onCancel={() => this.setState({selectPdfDatesVisible: false})} onOkClicked={(dateFrom, dateTo) => {
          const cookies = new Cookies();
          cookies.set('currentInsegnante', this.state.pdfElem ? this.state.pdfElem : this.state.pdfGroupElem, { path: '/' });
          cookies.set('dateFrom', dateFrom, { path: '/' });
          cookies.set('dateTo', dateTo, { path: '/' });
          window.location.href= this.state.pdfElem ? this.dbPath + '/#/app/pdfInsegnantiPage' : this.dbPath + '/#/app/pdfInsegnantiGroupPage';
        }}/>

    <FusioneWidget show={this.state.fusioneEnabled} key={Math.random()} onCancel={() => this.setState({fusioneEnabled: false})} onOkClicked={async (nome, listInsegnanti) => {

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });

          var insegnanti = '';
          listInsegnanti.forEach(i => {
              insegnanti += i.value + '---';
          })
          var ret = await addGruppoInsegnanti(username, token, nome, insegnanti);

          var newUsername = await Utils.generateUsername(username, token, nome, '');
          var password = Utils.generatePassword();
          await addUtente(username, token, '', '', newUsername, password, 3, ret.id);
          
          this.setState({fusioneEnabled: false})
          this.reload();

        }}/>

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        <WaitDialogFileDownload onClose={() => this.setState({waitDialogFileVisible: false})} show={this.state.waitDialogFileVisible} ready={this.state.fileReady} file={'https://' + Constants.mainUrl + 'pdf/fatturazione.xlsx'} key={Math.random()} index={this.state.index}/>
      </div>
    );
  }
}

